import { createRouter, createWebHistory } from 'vue-router'
import PrivacyView from '../views/Privacy.vue'
import HomeView from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/privacy-policy',
    name: 'Privacy',
    component: PrivacyView
  },
  {
    path: '/Service_Terms',
    name: 'Terms',
    component: () => import('../views/Terms.vue')
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes
})

export default router 